import './ProgressBar.css'

interface ProgressBarProps {
    percent: number
    label?: string
}

export default function ProgressBar({ percent, label }: ProgressBarProps) {
    return (
        <div className="progress-bar-wrapper">
            <div className="progress-bar-track">
                <div className="progress-bar-fill" style={{ width: `${percent}%` }} />
            </div>
            {label && (
                <p className="progress-bar-text">{label}</p>
            )}
        </div>
    )
}
